"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _mobx = require("mobx");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function useSearchPageProps(store) {
  var getState = function getState(store) {
    return {
      activeTabIndex: store.appStore.searchPage.activeTabIndex,
      setActiveTabIndex: store.appStore.searchPage.setActiveTabIndex,
      getBranchesByCityId: store.appStore.searchPage.getBranchesByCityId,
      language: store.appStore.config.locale,
      pickupBranch: store.appStore.searchPage.pickupBranch,
      dropoffBranch: store.appStore.searchPage.dropoffBranch,
      setPickUpBranch: store.appStore.searchPage.setPickUpBranch,
      setDropOffBranch: store.appStore.searchPage.setDropOffBranch,
      isPickUpBranchSelected: store.appStore.searchPage.isPickUpBranchSelected,
      isDropOffBranchSelected: store.appStore.searchPage.isDropOffBranchSelected,
      isPickUpDialogOpen: store.appStore.searchPage.isPickUpDialogOpen,
      isDropOffDialogOpen: store.appStore.searchPage.isDropOffDialogOpen,
      setPickUpDialogOpen: store.appStore.searchPage.setPickUpDialogOpen,
      setDropOffDialogOpen: store.appStore.searchPage.setDropOffDialogOpen,
      isDropOffBranchSame: store.appStore.searchPage.isDropOffBranchSame,
      isDifferentCity: store.appStore.searchPage.isDifferentCity,
      setSwitchState: store.appStore.searchPage.setSwitchState,
      isSwitchOn: store.appStore.searchPage.isSwitchOn,
      isDeliveryTabActive: store.appStore.searchPage.isDeliveryTabActive,
      pickupDate: store.appStore.searchPage.pickupDate,
      dropoffDate: store.appStore.searchPage.dropoffDate,
      setPickUpDate: store.appStore.searchPage.setPickUpDate,
      setDropOffDate: store.appStore.searchPage.setDropOffDate,
      diffInDays: store.appStore.searchPage.diffInDays,
      selectedDateRange: store.appStore.searchPage.selectedDateRange,
      pickupTime: store.appStore.searchPage.pickupTime,
      dropoffTime: store.appStore.searchPage.dropoffTime,
      setPickUpTime: store.appStore.searchPage.setPickUpTime,
      setDropOffTime: store.appStore.searchPage.setDropOffTime,
      searchQueryObject: store.appStore.searchPage.searchQueryObject,
      isSameDay: store.appStore.searchPage.isSameDay,
      isLoggedIn: store.appStore.accountPage.isLoggedIn,
      logout: store.appStore.accountPage.logout,
      searchQueryString: store.appStore.searchPage.searchQueryString,
      setIsBookingFlow: store.appStore.fleetDetailsPage.setIsBookingFlow,
      resetAllFilters: store.appStore.fleetPage.fleetFilter.resetAllFilters,
      branchHashMap: store.appStore.searchPage.branch.branchHashMap,
      searchDataUpdated: store.appStore.searchPage.searchDataUpdated,
      setSearchDataUpdated: store.appStore.searchPage.setSearchDataUpdated,
      openPickupTimer: store.appStore.searchPage.openPickupTimer,
      openDropoffTimer: store.appStore.searchPage.openDropoffTimer,
      setOpenPickupTimer: store.appStore.searchPage.setOpenPickupTimer,
      setOpenDropoffTimer: store.appStore.searchPage.setOpenDropoffTimer,
      minDaysOfDeliveryDropOff: store.appStore.searchPage.minDaysOfDeliveryDropOff,
      setActiveListBy: store.appStore.searchPage.setActiveListBy,
      getCityListByActiveTab: store.appStore.searchPage.getCityListByActiveTab,
      pickUpCount: store.appStore.searchPage.pickUpCount,
      carDeliveryCount: store.appStore.searchPage.carDeliveryCount,
      carDeliveryBranchList: store.appStore.searchPage.branch.carDeliveryBranchList,
      activeBranchList: store.appStore.searchPage.activeBranchList,
      getBranchByBranchId: store.appStore.searchPage.getBranchByBranchId,
      setMinDeliveryDays: store.appStore.searchPage.setMinDeliveryDays,
      isDropoffChargesLoading: store.appStore.searchPage.isLoading,
      hasDropoffChargesFailed: store.appStore.searchPage.hasFailed,
      dropoffCharge: store.appStore.searchPage.dropoffCharge,
      dropoffCategoryType: store.appStore.searchPage.dropoffCategoryType
    };
  };
  var _useState = (0, _react.useState)(getState(store)),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  (0, _react.useEffect)(function () {
    return (0, _mobx.autorun)(function () {
      return setState(getState(store));
    });
  }, [store]);
  return state;
}
var _default = exports["default"] = useSearchPageProps;